import _ from 'lodash';

import { INITIAL_PAGING } from '../redux';

export class ClientSidePagingManager {
  constructor(fetchFunction, getPageableList, setList) {
    this.paramCache = {};
    this.list = [];
    this.paging = INITIAL_PAGING;
    this.sorting = null;
    this.fetchFunction = fetchFunction;
    this.getPageableList = getPageableList;
    this.setList = setList;
  }

  setPagedList = () => {
    const { page, pageSize } = this.paging;

    let sortedList = this.list;

    if (this.sorting) {
      if (this.sorting.desc) {
        sortedList = _.sortBy(sortedList, this.sorting.id).reverse();
      } else {
        sortedList = _.sortBy(sortedList, this.sorting.id);
      }
    }

    this.setList(sortedList.slice((page - 1) * pageSize, page * pageSize));
  };

  getPaging = () => {
    return this.paging;
  };

  refresh = () => {
    this.list = this.getPageableList();
    this.paging = {
      page: this.paging.page,
      pageSize: this.paging.pageSize,
      totalResults: this.list.length,
      totalPages: Math.ceil(this.list.length / this.paging.pageSize),
    };
    this.setPagedList();
  };

  fetch = async params => {
    this.paramCache = { ...params };
    await this.fetchFunction({ ...params });
    this.paging.page = 1;
    this.refresh();
  };

  goToPage = async page => {
    this.paging = { ...this.paging, page };
    this.setPagedList();
  };

  next = async () => {
    const { page, totalPages } = this.getPaging();
    if (page < totalPages) {
      this.goToPage(page + 1);
    }
  };

  previous = async () => {
    const { page } = this.getPaging();

    if (page > 1) {
      this.goToPage(page - 1);
    }
  };

  sort = columns => {
    this.sorting = columns[0];
    this.refresh();
  };

  refetch = async () => {
    await this.fetchFunction(this.paramCache);
    this.refresh();
  };
}
